import styled from "styled-components";

export const Flag = styled.div<{ width: string }>`
  width: ${({ width }) => width};
`;
